<!--
@component
HomePage

See markup below.
-->

<script lang="ts">
  import { appState } from '$lib/stores/index.svelte';
  import { BodyText } from '@reuters-graphics/graphics-components';
  import Headline from '$lib/components/common/Headline/index.svelte';
  import Banner from '$lib/components/HomePage/Banner/index.svelte';
  import Bracket from '$lib/components/KnockoutsPage/index.svelte';
  import GroupTable from '$lib/components/GroupTable/index.svelte';
  import { isReutersDev } from '$utils/env';
  import { InlineAd } from '@reuters-graphics/graphics-components';

  /** A single content block coming from the storyboard. */
  interface ContentBlock {
    type: string;
    text?: string;
    [key: string]: unknown;
  }

  interface ReferralContent {
    heading?: string;
    section?: string;
    class?: string;
  }

  interface Content {
    hed: string;
    blocks: ContentBlock[];
    referral?: ReferralContent;
    [key: string]: unknown;
  }

  interface Props {
    // `data` is a deeply-nested Opta payload; keep loose here and let
    // downstream components narrow it as needed.
    data: any;
    content: Content;
  }

  const { data, content }: Props = $props();
</script>

<Banner />
<Headline content={{ hed: content.hed }} />

<!-- 🔁 Render storyboard blocks -->
{#each content.blocks as block, i (i)}
  {#if block.type === 'text'}
    <BodyText text={block.text ?? ''} />
  {:else if block.type === 'inline-ad'}
    <InlineAd />
  {:else if appState.currentUrl && isReutersDev(appState.currentUrl)}
    <!-- Surface unknown block types in dev/preview only, without leaking to prod logs -->
    {void console.warn(`[Home] Unknown block type: "${block.type}"`)}
  {/if}
{/each}

{#if appState.showKnockouts}
  <Bracket {data} />
{:else}
  <GroupTable {data} />
{/if}
